<template>
  <svg
    width="6"
    height="4"
    viewBox="0 0 6 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.00002 0L6 4H0L3.00002 0Z" fill="#2EC743" />
  </svg>
</template>
